/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */

import * as React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../../../locales.json";
import DOMPurify from "dompurify";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import { datadogRum } from "@datadog/browser-rum";
import styled from "styled-components";

import * as API from "../../../../api/billing";
import Modal from "../../../../components/reusable/reactModal";
import {
  StyledButton,
  StyledButtonContainer,
  StyledModalBody,
  StyledModalContents,
  StyledModalText,
} from "../lib/styles";
import { CatalogShutoffModalProps } from "../lib/types";
import { handleErrorsArray } from "../../../../utils";


const StyledDescription = styled(StyledModalText)`
  margin-bottom:16px;
`;

const CatalogShutoffModal = ({
  catalogShutoff,
  closeModal,
  updateToastMessage,
  fetchData,
}: CatalogShutoffModalProps): React.ReactElement => {
  const handleCatalogShutoffClick = async (): Promise<void> => {
    try {
      const data = {
        catalog_shutoff: !catalogShutoff,
      };
      await API.updateCompanyCatalogShutoff(data);

      updateToastMessage({
        isOpen: true,
        message: "Company reward catalog has been updated",
        type: "success",
      });
      fetchData();
      closeModal();
    } catch (error) {
      const errors = handleErrorsArray(error);

      datadogRum.addError(errors);
      updateToastMessage({
        isOpen: true,
        message: i18n.translate(
          "admin_pages.settings.subscription.reactivate_error"
        ),
        type: "error",
      });
    }
  };

  return (
      <StyledModalBody data-testid="catalog-shutoff-modal-body">
        <StyledModalContents>
          <StyledDescription>
          {catalogShutoff ? "Are you sure you want to reactivate the company reward catalog" : "Are you sure you want to shut off the company reward catalog?"}
          </StyledDescription>

        </StyledModalContents>
        <StyledButtonContainer>
          <StyledButton
            onClick={closeModal}
            size="small"
            testId="cancel-button"
            variant="secondary"
          >
            {i18n.translate("forms.cancel")}
          </StyledButton>
          <StyledButton
            onClick={handleCatalogShutoffClick}
            size="small"
            testId="catalog-shutoff-button"
            variant="primary"
          >
            {catalogShutoff ? "Turn On" : "Shut Off"}
          </StyledButton>
        </StyledButtonContainer>
      </StyledModalBody>
  );
};

export default CatalogShutoffModal;
